///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-users.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class CSEProductsWithCategoriesDataTemplate extends DataTemplateBase implements IDataTemplate {
        protected productCategories: ProductCategoriesCollection;
        protected products: CSEProductVariantsCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;
        public totalParentSelectedMessage: string;

        get collection() {
            return this.productCategories;
        }

        get totalSelectedCount(): number {
            return this.products.value.length;
        }

        get totalParentSelectedCount(): number {
            return this.productCategories.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.productCategories = new ProductCategoriesCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });
            this.products = new CSEProductVariantsCollection(this.model[properties[1]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.products.setParentCollection(this.productCategories, CoreProductVariantToCategoryStrategy);

            this.filters = [
                new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE_EMPLOYEES'}, this)
            ];
            this.products.addFilters(...this.filters as IInteractiveFilter[]);

            this.title = 'LABEL_PRODUCT_CATEGORY_PRODUCT';
            this.allSelectedLabel = 'LABEL_ALL_PRODUCTS';
            this.totalSelectedMessage = 'LABEL_PRODUCTS_SELECTED';
            this.totalParentSelectedMessage = 'LABEL_TOTAL_PRODUCT_CATEGORIES_SELECTED';
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this.products.setWatchers(scope);
        }

        onHideToggle(hidden: boolean): void {
            this.smartMoverHidden = hidden;
        }
    }
}
